/** @format */

import {isSameDay} from 'date-fns';

import {DateTuple} from '../model';

type ReturnDates = {
  start: Date;
  end: Date;
} | null;

/**
 * Вернет null, если даты не валидны, в противном случае вернет объект start и end
 * @param tuple
 * @param allowSameDay - флаг для разрешения одинаковых дат
 */

const validateDatesRange = (tuple: DateTuple, allowSameDay = false): ReturnDates => {
  const start = tuple[0];
  const end = tuple[1];

  if (start === null || end === null) {
    return null;
  }

  if (!allowSameDay && isSameDay(start, end)) {
    return null;
  }

  return {start, end};
};

export default validateDatesRange;
